import React from 'react'
import './index.scss'
import { connect } from 'react-redux'
import { openModal } from '../../../../../action/positioned-modal-state'

const SubPopup = props => {
  const { hidePopup, openModal } = props

  return (
    <div className='wind-sub-bg' onClick={e => { e.stopPropagation() }}>
      <div className='wind-sub-fg center'>
        <p style={{ fontSize: '30px', fontWeight: 'bold', marginBottom: '10px' }}>Pro Subscription Required</p>
        <p style={{ marginBottom: '10px' }}>Please upgrade to a PRO subscription to view future wind.</p>
        <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
          <button style={{ width: '30%', backgroundColor: 'gray' }} onClick={hidePopup}>Cancel</button>
          <button style={{ width: '30%' }} onClick={openModal}>View Plans</button>
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = state => ({

})

const mapDispatchToProps = dispatch => ({
  openModal: () => dispatch(openModal({ subInfo: true }))
})

export default connect(mapStateToProps, mapDispatchToProps)(SubPopup)